import { defineStore } from 'pinia'
import api from '@/utils/axios'
import { applyBrandTheme } from '@/utils/brandTheme'

export const useSettingsStore = defineStore('settings', {
  state: () => ({
    logo: '' as string,
    name: '' as string,
    primaryColor: '' as string,
    secondaryColor: '' as string,
    // currency saved in Paramètres généraux (settings.devis)
    currency: 'DH' as string,
  }),
  actions: {
    async fetchSettings() {
      try {
        const res = await api.get('/api/auth/general_list')
        if (res.data) {
          this.logo = res.data.logo || ''
          this.name = res.data.name || ''
          this.primaryColor = res.data.primary_color || ''
          this.secondaryColor = res.data.secondary_color || ''
          this.currency = res.data.devis || 'DH'
          applyBrandTheme(this.primaryColor, this.secondaryColor)
        }
      } catch (err) {
        console.error('Failed to load app settings', err)
      }
    },
  },
})
